import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';

// @ts-expect-error No types for PatternValidationJS
import UrlParts from 'PatternValidationJS/regex/parts/UrlParts';
import { LinkRelDefault, LinkTypes, LinkRelTypes } from '../constants/link';
const emailQueryWord = '([^\\s?=&]+)';
const emailQueryParamater = `${emailQueryWord}=${emailQueryWord}`;
const emailQueryExpression = `\\?${emailQueryParamater}(&${emailQueryParamater})*`;
const EMAIL_ADDRESS_REGEX = new RegExp(`^(.+)@${UrlParts.domain}(${emailQueryExpression})?$`);
const ANCHOR_REGEX = new RegExp(/^#\S/);
const TEL_REGEX = new RegExp(/^[t|T][e|E][l|L]:[\d+-]*$/);
const RELATIVE_URL_REGEX = new RegExp(/^\/\S/);
// Exact copy of UrlRegexFactory from PatternValidationJS, but with required protocol
const URL_REGEX_WITH_REQUIRED_PROTOCOL_REGEX = new RegExp(`^${UrlParts.protocol}${UrlParts.domain}(${UrlParts.path}(${UrlParts.file})?)?${UrlParts.search}?$`, 'i');
const HUBL_REGEX = new RegExp(/^(\S*{{.+}}\S*)+$/);
const relTrackingKeys = Object.values(LinkRelTypes).filter(value => value !== LinkRelTypes.REGULAR);
function trimLeadingSlash(string) {
  return string.split('/').splice(1).join('/');
}
export function getUrlParts(href) {
  const anchor = document.createElement('a');
  anchor.href = href;
  return {
    domain: anchor.hostname,
    protocol: anchor.protocol,
    slug: trimLeadingSlash(anchor.pathname)
  };
}
export function getMeetingLinkSlug(href) {
  let {
    slug
  } = getUrlParts(href);
  const match = /^meetings\/(.+)/.exec(slug);
  if (match && match[1]) {
    slug = encodeURIComponent(match[1]);
  }
  return slug;
}
export function formatUserName(user) {
  const {
    firstName,
    lastName,
    email
  } = user;
  if (firstName || lastName) {
    return `${firstName || ''} ${lastName || ''}`.trim();
  }
  return email;
}
export function validateEmail(link) {
  const email = link.replace(/^mailto:/, '');
  return EMAIL_ADDRESS_REGEX.test(email) || HUBL_REGEX.test(email);
}
export function validateUrl(link) {
  return ANCHOR_REGEX.test(link) || TEL_REGEX.test(link) || RELATIVE_URL_REGEX.test(link) ||
  // Catastrophic backtracking may occur when a space is present
  URL_REGEX_WITH_REQUIRED_PROTOCOL_REGEX.test(link.replaceAll(/\s+/g, '')) || HUBL_REGEX.test(link);
}
export function validateLink(linkType, link) {
  switch (linkType) {
    case LinkTypes.EMAIL:
      return validateEmail(link);
    case LinkTypes.URL:
      return validateUrl(link);
    default:
      return true;
  }
}
export const getSetupMeetingLinkUrl = () => `${getFullUrl('app')}/meetings/${PortalIdParser.get()}/link/new`;
export const isMeetingLink = href => {
  const {
    slug,
    domain
  } = getUrlParts(href);
  return slug.startsWith('meetings/') || domain.startsWith('meetings.hubspot');
};
export const alphabeticalSort = (a, b) => {
  if (a.text < b.text) return -1;else if (a.text > b.text) return 1;else return 0;
};
export const getAlphabeticalSortPrioritizingUser = userId => (a, b) => {
  if (a.userId === userId) return -1;else if (b.userId === userId) return 1;else return alphabeticalSort(a, b);
};
export const getRelAttrTrackingValues = (relAttr = []) => {
  const trackingValues = relAttr.reduce((acc, value) => {
    if (value === LinkRelDefault ||
    // @ts-expect-error ~ Argument of type 'LinkRelTypes' is not assignable to parameter of type 'LinkRelTypes.NOFOLLOW | LinkRelTypes.SPONSORED | LinkRelTypes.UGC'
    !relTrackingKeys.includes(value)) {
      return acc;
    }
    acc[value] = true;
    return acc;
  }, {});
  return trackingValues;
};